'use client';

import { getCountries } from '@/app/utils/fetchdata';
import { useFormStatus } from 'react-dom';
import { useContext, useEffect, useState, useActionState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { RegionalContext } from '@/app/providers/regionalTextProvider';
import { useTranslations } from 'next-intl';

function SubmitButton() {
  const { pending } = useFormStatus();
  const dict = useTranslations('toc_popUp.sub_btn');
  return (
    <button
      className="btn btn-toc-submit"
      title="Submit"
      type="submit"
      disabled={pending}
    >
      {pending ? (
        <div className="flex" disabled={pending}>
          <FaSpinner className="animate-spin me-2" size={'25'} />{' '}
          <span>{dict('submitting')}..</span>
        </div>
      ) : (
        `${dict('text')}`
      )}
    </button>
  );
}

export default function Form({
  formAction,
  formType,
  keyword,
  CustomName,
  reportId,
  setIsSubmitted,
}) {
  const [formState, action] = useActionState(formAction, 'Submitting!');
  const [countryList, setCountryList] = useState([]);
  const dict = useTranslations('toc_popUp');

  //Fetching Countries
  useEffect(() => {
    async function fetchData() {
      const data = await getCountries();
      setCountryList(data);
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (formState.success) {
      setIsSubmitted(true);
    }
  }, [formState]); //eslint-disable-line

  return (
    <div className="mt-4 w-full mx-auto">
      <form id="dataFormSide" action={action}>
        <input value={formType} type="hidden" name="formType" />
        <input value={CustomName} type="hidden" name="CustomName" />
        <input value={keyword} type="hidden" name="keyword" />
        <input value={reportId} type="hidden" name="reportId" />
        <div className="mb-3">
          <input
            name="name"
            placeholder={dict('name')}
            required
            type="text"
            id="minames"
            className="form-control email-box form-control"
          />
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.name}</p>
          )}
        </div>
        <div className="mb-3">
          <input
            name="email"
            placeholder={dict('email')}
            required
            type="email"
            id="miemails"
            className="form-control email-box form-control"
          />
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.email}</p>
          )}
        </div>
        <div className="flex mb-3">
          <div className="w-1/3 pe-0">
            <select
              className="form-control select-drop p-1"
              name="country"
              required
              id="countrys"
            >
              <option value="">{dict('country')}</option>
              {countryList.map((item) => {
                return (
                  <option key={item.name} value={item.name}>
                    {item.name}(+ {item.dailcode})
                  </option>
                );
              })}
            </select>
            {formState.errors && (
              <p className=" text-red-600 text-start">
                {formState.errors.country}
              </p>
            )}
          </div>
          <div className="ps-0">
            <input
              name="phone"
              placeholder={dict('phone')}
              required
              type="text"
              id="miphones"
              className="form-control phone-box"
            />
          </div>
          {formState.errors && (
            <p className=" text-red-600 text-start">{formState.errors.phone}</p>
          )}
        </div>
        <div>
          <select
            id="interest"
            name="interest"
            required
            className=" form-control select-drop p-1 "
          >
            <option>{dict('interest.title')}</option>
            <option value={1}>{dict('interest.opt1')}</option>
            <option value={2}>{dict('interest.opt2')}</option>
          </select>
        </div>
        <div className="my-3">
          <textarea
            name="comment"
            id="miinterests"
            placeholder={dict('desc')}
            className="form-control descrip-box py-1 px-3"
            required
          ></textarea>
          {formState.errors && (
            <p className=" text-red-600 text-start">
              {formState.errors.interest}
            </p>
          )}
        </div>
        <SubmitButton />
      </form>
    </div>
  );
}
